export default "__VITE_ASSET__Bj3jD$8j__"